'use client';

import type { GetProposalGoodsServiceResponse } from '@musinsa/services-curator';
import { useInfiniteQuery } from '@tanstack/react-query';
import { curatorQueries } from '../../query-factory';

export const useProposalGoods = (campaignProposalId: number | undefined, size = 10) => {
  return useInfiniteQuery({
    ...curatorQueries.campaigns.proposalGoods({
      campaignProposalId: campaignProposalId!,
      size,
    }),
    initialPageParam: 1,
    getNextPageParam: (lastPage: GetProposalGoodsServiceResponse) =>
      lastPage.pagination.hasNextPage ? lastPage.pagination.nextPage : undefined,
    enabled: campaignProposalId !== undefined,
  });
};
